module.exports = __webpack_public_path__ + "img/HZ-T1513.c6a6aae2.jpg";